import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Flag, CheckCircle2 as CheckCircle, X } from "lucide-react";
import { toast } from "sonner";

export default function KnowledgeFlags() {
  const [flags, setFlags] = useState([]);
  const [status, setStatus] = useState("pending");
  const [brands, setBrands] = useState([]);

  const load = () => api.listFlags(status).then(setFlags);
  useEffect(() => { load(); }, [status]);
  useEffect(() => { api.listBrands().then(setBrands); }, []);

  const confirm = async (id, action) => {
    await api.confirmFlag(id, action);
    toast.success(action === "accept" ? "Added to pipeline" : "Dismissed");
    load();
  };

  return (
    <div data-testid="flags-page" className="max-w-5xl">
      <div className="mb-10">
        <div className="text-eyebrow mb-3">Knowledge Pipeline</div>
        <h1 className="font-display font-black text-5xl tracking-tighter">Significant Updates</h1>
        <p className="text-[#52525B] mt-3">When you add meaningful new info, we flag it. Confirm to feed it into all future content.</p>
      </div>

      <div className="flex gap-2 mb-6">
        {["pending", "accepted", "dismissed"].map((s) => (
          <button key={s} onClick={() => setStatus(s)}
                  data-testid={`status-tab-${s}`}
                  className={`px-4 py-2 text-sm border ${status === s ? "bg-[#0A0A0B] text-white border-[#0A0A0B]" : "bg-white border-[#E2E4E9]"}`}>
            {s.charAt(0).toUpperCase() + s.slice(1)}
          </button>
        ))}
      </div>

      {flags.length === 0 ? (
        <div className="border-2 border-dashed border-[#E2E4E9] p-16 text-center">
          <Flag size={48} className="mx-auto text-[#A1A1AA]" />
          <p className="font-display font-bold text-2xl mt-4">No flags here</p>
        </div>
      ) : (
        <div className="space-y-3">
          {flags.map((f) => {
            const b = brands.find((x) => x.brand_id === f.brand_id);
            return (
              <div key={f.flag_id} data-testid={`flag-${f.flag_id}`} className="border border-[#E2E4E9] p-5">
                <div className="flex items-start justify-between gap-4">
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-2">
                      <Flag size={14} />
                      <span className="text-xs mono uppercase text-[#52525B]">{b?.name || "Brand"}</span>
                      <span className="text-xs mono text-[#A1A1AA]">{(f.created_at || "").slice(0, 16)}</span>
                    </div>
                    <p className="font-display font-bold text-xl tracking-tight">{f.summary}</p>
                    {f.raw && <p className="text-sm text-[#52525B] mt-2 line-clamp-3">"{f.raw}"</p>}
                  </div>
                  {status === "pending" && (
                    <div className="flex flex-col gap-2 w-44">
                      <button onClick={() => confirm(f.flag_id, "accept")} data-testid={`accept-flag-${f.flag_id}`}
                              className="px-4 py-2 text-sm bg-[#059669] text-white flex items-center gap-2 justify-center">
                        <CheckCircle size={14} /> Confirm
                      </button>
                      <button onClick={() => confirm(f.flag_id, "dismiss")} data-testid={`dismiss-flag-${f.flag_id}`}
                              className="px-4 py-2 text-sm border border-[#E11D48] text-[#E11D48] flex items-center gap-2 justify-center">
                        <X size={14} /> Dismiss
                      </button>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
